// What an issue photo may be — the backend's upload rule (`image-upload.ts`:
// JPEG, PNG, WebP or GIF), checked before uploading so a bad file fails at once.

export const ISSUE_PHOTO_TYPES: readonly string[] = ['image/jpeg', 'image/png', 'image/webp', 'image/gif'];
export const ISSUE_PHOTO_MAX_BYTES = 10 * 1024 * 1024;

/** Whether a photo can be uploaded; a size the picker didn't report passes. */
export function isUploadablePhoto(type: string, size?: number): boolean {
  return ISSUE_PHOTO_TYPES.includes(type) && (size === undefined || size <= ISSUE_PHOTO_MAX_BYTES);
}
